module.exports = __webpack_public_path__ + "static/media/Certificado_de_Cobertura_Seguro.4d9a6ec2.pdf";